import { SyncAnalysis, SyncAnalysisFinding } from '../../models/Entities/Protocols/SyncAnalysis';
import { PaginationState } from '../../models/PaginationState';
import { ErrorType } from '../../models/HttpError';
import { SYNC_ANALYSIS_FINDINGS_DEFAULT_PAGE_SIZE } from '../../services/ProtocolConsumptionSyncAnalysis.Service';

export const EmptyFindingsPaginationState: PaginationState = {
	pageNumber: 1,
	pageSize: SYNC_ANALYSIS_FINDINGS_DEFAULT_PAGE_SIZE,
	totalPages: 0,
	totalRecords: 0,
};

export interface ProtocolConsumptionSyncAnalysisState {
	/**
	 * Análisis por corrida. Se indexa por syncProcessId en lugar de guardar uno
	 * solo: el panel de sincronización puede abrirse sobre distintas corridas y
	 * mostrar el análisis de otra sería peor que no mostrar ninguno.
	 */
	analysisBySyncProcessId: Record<string, SyncAnalysis | null>;
	isGettingAnalysis: boolean;
	successGettingAnalysis: boolean | undefined;
	failOnGettingAnalysis: boolean;

	/**
	 * Ejecución a demanda del análisis. El endpoint es sincrónico —responde recién
	 * cuando terminó— así que esta bandera cubre toda la corrida del análisis, no
	 * sólo el viaje de ida del pedido.
	 */
	isExecutingAnalysis: boolean;
	successExecutingAnalysis: boolean | undefined;
	failOnExecutingAnalysis: boolean;
	/**
	 * Corrida de la última ejecución pedida. Las banderas de arriba son del slice
	 * entero, así que sin esto el panel abierto sobre otra corrida mostraría como
	 * propio un análisis —o un error— que no le corresponde.
	 */
	executionSyncProcessId?: string;
	/**
	 * El error de la ejecución va aparte de `error`: al terminar se relee el
	 * análisis, y ese pedido limpia `error` y se llevaría puesto el motivo por
	 * el que la ejecución no prosperó.
	 */
	executionError?: ErrorType;

	/** Sólo la página cargada de cada análisis; el listado lo pagina el servidor. */
	findingsByAnalysisId: Record<string, SyncAnalysisFinding[]>;
	findingsPaginationByAnalysisId: Record<string, PaginationState>;
	isGettingFindings: boolean;
	successGettingFindings: boolean | undefined;
	failOnGettingFindings: boolean;

	/** Decisión en curso sobre un hallazgo; el id dice cuál, para deshabilitar sólo esa tarjeta. */
	isSettingDecision: boolean;
	decisionFindingId?: string;
	failOnSettingDecision: boolean;
	decisionError?: ErrorType;

	error?: ErrorType;
}

export const ProtocolConsumptionSyncAnalysisUnloadState: ProtocolConsumptionSyncAnalysisState = {
	analysisBySyncProcessId: {},
	isGettingAnalysis: false,
	successGettingAnalysis: undefined,
	failOnGettingAnalysis: false,

	isExecutingAnalysis: false,
	successExecutingAnalysis: undefined,
	failOnExecutingAnalysis: false,
	executionSyncProcessId: undefined,
	executionError: undefined,

	findingsByAnalysisId: {},
	findingsPaginationByAnalysisId: {},
	isGettingFindings: false,
	successGettingFindings: undefined,
	failOnGettingFindings: false,

	isSettingDecision: false,
	decisionFindingId: undefined,
	failOnSettingDecision: false,
	decisionError: undefined,

	error: undefined,
};
